import VeeValidate from "vee-validate";
import { CommonCsvFunctions } from "../../mixins/processCsvFunctions/commonCsvFunctions.mixin";
import store from "../store/store";
import { mapState, mapActions } from "vuex";

const ValidateHelperFns = CommonCsvFunctions.methods;
const itemTypeValues = [
	"sku",
	"raw material",
	"serveware",
	"consumable",
	"cleaning",
	"equipment",
	"miscellaneous",
	"menu item"
];
const storeFns = {
	computed: {
		...mapState("UploadCsvStore", [
			"articleCodeUniqueValueCheck",
			"CategoryCheckInAM",
			"SubCategoryCheckInAM"
		])
	},
	methods: {
		...mapActions("UploadCsvStore", [
			"updateArticleCodeUniqueValueCheck",
			"UpdateCategoryCheckInAM",
			"UpdateSubCategoryCheckInAM"
		])
	}
};
// console.log(
// 	"articleCodeUniqueValueCheck",
// 	storeFns.computed.articleCodeUniqueValueCheck
// );

VeeValidate.Validator.extend("unique", {
	getMessage: (field, params, data) => data.message,
	validate: (value, [articleMasterDB, index]) => {
		return new Promise(resolve => {
			setTimeout(() => {
				if (
					articleMasterDB
						.filter(article => articleMasterDB.indexOf(article) !== index)
						.map(article => article.itemCode)
						.indexOf(value) === -1
				) {
					return resolve({
						valid: true
					});
				}

				return resolve({
					valid: false,
					data: {
						message: `${value} is already taken.`
					}
				});
			}, 200);
		});
	}
});
